import { useContext, useLayoutEffect, useState } from 'react';
import { reduce } from 'underscore';
import { Context } from 'app/index';

function getOffsetTop(element) {
    return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}

export const useScrollIndicator = (ids, offset = 0) => {
    const [activeId, setActiveId] = useState('');
    const {
        isSticky: [isSticky],
    } = useContext(Context);
    useLayoutEffect(() => {
        const listener = () => {
            const scroll = document.body.scrollTop;
            const nav = isSticky
                ? parseInt(
                      getComputedStyle(document.body).getPropertyValue('--nav')
                  )
                : 0;
            const el = document.querySelector('.lending-sections');
            const gap = el
                ? parseInt(
                      window.getComputedStyle(el).getPropertyValue('row-gap')
                  )
                : 0;
            const position = ids
                .map((id) => {
                    const elements = document.querySelectorAll(
                        `[data-section-id="${id}"]`
                    );
                    if (!elements) return { id, element: null };
                    return { id, elements };
                })
                .find(({ elements, id }) => {
                    if (!elements?.length) return;
                    const offsetFirst = getOffsetTop(elements[0]);
                    const totalHeight = reduce(
                        elements,
                        (prev, curr, index) => {
                            const needGap = index !== 0;
                            return (
                                prev + curr.offsetHeight + (needGap ? gap : 0)
                            );
                        },
                        0
                    );
                    if (
                        scroll >= offsetFirst - nav &&
                        scroll <= offsetFirst + totalHeight - nav
                    ) {
                        return id;
                    }
                });
            setActiveId(position?.id || '');
        };

        listener();

        document.body.addEventListener('resize', listener);
        document.body.addEventListener('scroll', listener);

        return () => {
            document.body.removeEventListener('resize', listener);
            document.body.removeEventListener('scroll', listener);
        };
    }, [ids, offset]);

    return activeId;
};
